import React, { useState, useEffect } from "react";
import LabelInput from "./labelInput";
import DateField from "./dateField";
import { assetsPath } from "../utils/assetsPath";
import { assetUrl } from "fusion-core";
import {
  fetchMakes,
  fetchModels,
  fetchModifications,
  fetchSecurity,
  fetchVehicleData,
  fetchVehicleRegData,
} from "../services/simpleListItemsService";

const VehicleLookupNew = ({
  STATE,
  prevVeh = false,
  formMethods,
  errorVR,
  setErrorVR,
}) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    getValues,
    control,
    trigger,
    unregister,
  } = formMethods;
  const [modifications, setModifications] = useState([]);
  const [loader, setLoader] = useState(false);
  const [make, setMake] = useState([]);
  const [model, setModel] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [security, setSecurity] = useState([]);
  const [vehicleR, setVehicleR] = useState(null);
  const [first, setfirst] = useState(true);
  const [selectedVehicleIndex, setSelectedVehicleIndex] = useState(null);
  const [vehSelected, setVehSelected] = useState(false);
  const [isPrevVeh, setIsPrevVeh] = useState(prevVeh);
  const [showPrevButtons, setShowPrevButtons] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [vehicleListIsLoading, setVehicleListIsLoading] = useState(null);
  const [makesLoading, setMakesLoading] = useState(false);
  const [modelsLoading, setModelsLoading] = useState(false);

  const Capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const convertArrayFormat = (array) => {
    return Array.isArray(array)
      ? array.map((item) => ({
          value: item.listItemId,
          label: item.listItemDescription,
        }))
      : [];
  };

  const VehicleReg = watch("VehicleReg");
  const prevVehicleRegis = watch("prevVehicleRegis");
  const modelSearch = watch(prevVeh ? "prevModel" : "vModel")?.value;
  const makeSearch = watch(prevVeh ? "prevMake" : "vMake")?.value;
  const Vehmodel = watch(prevVeh ? "prevModel" : "vModel") || [];
  const modeloptions = model ? convertArrayFormat(model) : [];
  var vehicleYear = watch(prevVeh ? "prevVehicleYear" : "vehicleYear") || {};
  var vehicleYearValue = vehicleYear.value || "";
  var vehicleDoor = watch(prevVeh ? "prevVehicleDoor" : "vehicleDoor") || {};
  var vehicleDoorvalue = vehicleDoor.value || "";

  const fetchData = async () => {
    if (makeSearch && makeSearch != null) {
      try {
        setVehicleListIsLoading(true);
        const result = await fetchVehicleData({
          makeSearch,
          modelSearch,
          vehicleYearValue,
          vehicleDoorvalue,
        });
        setValue(
          prevVeh ? "prevVehiclesList" : "vehiclesList",
          result.vehicles
        );
        if (result.isSearchSuccess) {
          setVehicles(result.vehicles);
        }

        setValue(
          prevVeh ? "prevVehicleListLength" : "vehicleListLength",
          result.vehicles.length
        );
        setValue(
          prevVeh ? "prevVehicleYearsList" : "vehicleYearsList",
          result.years
        );
        setValue(
          prevVeh ? "prevVehicleDoorsList" : "vehicleDoorsList",
          result.doors
        );
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      } finally {
        setVehicleListIsLoading(false);
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    if (STATE.isManualVehicleEntry) {
      setErrorVR("");
    }
  }, [STATE.isManualVehicleEntry]);

  useEffect(() => {
    if (!first) {
      if (model) {
        fetchData(true);
        setValue(prevVeh ? "prevVehicleYearsList" : "vehicleYearsList", "");
        setValue(prevVeh ? "prevVehicleYear" : "vehicleYear", "");
        setValue(prevVeh ? "prevVehicleDoor" : "vehicleDoor", "");
        setValue(prevVeh ? "prevVehicleDoorsList" : "vehicleDoorsList", "");
        setValue("setSelectedVehicleIndex", null);
      }
    }
  }, [modelSearch]);

  useEffect(() => {
    if (!first) {
      if (make) {
        fetchData();
        setValue(prevVeh ? "prevVehicleYear" : "vehicleYear", "");
        setValue(prevVeh ? "prevVehicleYearsList" : "vehicleYearsList", "");
        setValue(prevVeh ? "prevVehicleDoorsList" : "vehicleDoorsList", "");
        setValue(prevVeh ? "prevVehicleDoor" : "vehicleDoor", "");
        setValue("setSelectedVehicleIndex", null);
        setValue(prevVeh ? "prevModel" : "vModel", "");

        setVehicles([]);
      }
    }
  }, [makeSearch]);

  useEffect(() => {
    if (!first) {
      if (watch(prevVeh ? "prevVehicleYearsList" : "vehicleYearsList")) {
        fetchData();
        setValue(prevVeh ? "prevVehicleDoor" : "vehicleDoor", "");
        setValue("setSelectedVehicleIndex", null);
      }
    }
  }, [watch(prevVeh ? "prevVehicleYear" : "vehicleYear")]);

  useEffect(() => {
    if (STATE.isManualVehicleEntry && makeSearch && modelSearch) {
      fetchData();
    }
  }, [makeSearch, modelSearch]);

  useEffect(() => {
    if (!first) {
      if (watch(prevVeh ? "prevVehicleDoorsList" : "vehicleDoorsList")) {
        fetchData();
        setValue("setSelectedVehicleIndex", null);
      }
    }
  }, [watch(prevVeh ? "prevVehicleDoor" : "vehicleDoor")]);

  useEffect(() => {
    if (watch("setSelectedVehicleIndex")) {
      setVehSelected(true);
    }
  }, [selectedVehicleIndex]);

  const convertArrayFormat2 = (array) => {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.map((item) => ({
      value: item,
      label: item.toString(),
    }));
  };

  useEffect(() => {
    const fetchAndSetMakes = async () => {
      try {
        setMakesLoading(true);
        const makes = await fetchMakes();
        setMake(makes);
      } catch (error) {
        console.error("Error fetching makes:", error);
      } finally {
        setMakesLoading(false);
      }
    };

    fetchAndSetMakes();
  }, []);

  useEffect(() => {
    const fetchAndSetModels = async () => {
      try {
        setModelsLoading(true);
        if (makeSearch) {
          const models = await fetchModels(makeSearch);
          setModel(models);
        }
      } catch (error) {
        console.error("Error fetching models:", error);
      } finally {
        setModelsLoading(false);
      }
    };

    fetchAndSetModels();
  }, [makeSearch]);

  useEffect(() => {
    fetchSecurity().then((statuses) => setSecurity(statuses));
    fetchModifications().then((statuses) => setModifications(statuses));
  }, []);
  const handleVehicleReg = async () => {
    setLoader(true);

    try {
      let data = await fetchVehicleRegData(
        prevVeh ? prevVehicleRegis : VehicleReg
      );
      if (prevVeh) {
        setValue("prevVehicleAbiCode", data.vehicleFound?.abiCode);
        setValue("prevVehicleYear", data.vehicleFound?.year);
        setValue("prevVehicleMake", data.vehicleFound?.abiMake);
        setValue("prevVehicleModel", data.vehicleFound?.abiModel);
      }
      if (data.isVehicleFound) {
        if (data.vehicleFound) {
          setValue(
            prevVeh ? "prevVehicleCC" : "vehicleCC",
            data.vehicleFound.abiCC
          );
          setValue(
            prevVeh ? "prevBodyType" : "bodyType",
            data.vehicleFound.bodyType
          );
          setValue(
            prevVeh ? "prevVehicleCubicCapacity" : "vehicleCubicCapacity",
            data.vehicleFound.abiCC
          );
          setValue(
            prevVeh ? "prevVehicleRegDate" : "vehicleRegDate",
            data.vehicleFound?.dateFirstRegistered
          );
          setVehicleR(data.vehicleFound);
          setValue(
            prevVeh ? "prevLookupVehicleReg" : "lookupvehicleReg",
            data.vehicleFound
          );
          setValue(
            prevVeh ? "prevVehImported" : "vehImported",
            data.vehicleFound.imported === "true" ? "Yes" : "No"
          );
          setValue(prevVeh ? "prevSeats" : "seats", data.vehicleFound.seats);
          setValue(prevVeh ? "prevLookupData" : "lookupData", true);
          STATE.setLookupData(true);
          if (prevVeh) {
            setValue("prevLookupData", true);
            setValue("lookupData", false);
            STATE.setLookupData(false);
          } else {
            setValue("prevLookupData", false);
            setValue("lookupData", true);
            STATE.setLookupData(true);
          }
          setValue("valuesMach", false);
          setValue(prevVeh ? "prevRightHandDrive" : "rightHandDrive", "Yes");
          setValue(prevVeh ? "prevVehicleModified" : "vehicleModified", "No");
          setValue(prevVeh ? "prevVehicleQPlated" : "vehicleQPlated", "No");
          setErrorVR("");
        }
      } else {
        setErrorVR(
          "Vehicle registration data not found. Please enter details manually."
        );
        setValue(
          prevVeh ? "prevLookupVehicleReg" : "lookupvehicleReg",
          undefined
        );
        setVehicleR(null);
        // Switch to manual entry mode if not found
        if (prevVeh) {
          setIsPrevVeh(false);
          setShowPrevButtons(false);
        } else {
          STATE.setIsManualVehicleEntry(true);
          setValue(prevVeh ? "prevMake" : "vMake", {
            value: data.vehicleFound.abiMake,
          });
          setValue(prevVeh ? "prevModel" : "vModel", {
            value: Capitalize(data.vehicleFound.abiModel),
          });

          setValue(prevVeh ? "prevNoMatchedData" : "noMatchedData", true);
          setValue(prevVeh ? "prevVehiclesList" : "vehiclesList", "");
          setValue("setSelectedVehicleIndex", null);
        }
      }
    } catch (error) {
      setErrorVR(
        prevVeh
          ? "An error occurred while fetching previous vehicle registration data."
          : "An error occurred while fetching vehicle registration data."
      );
    } finally {
      setLoader(false);
    }
  };
  const vehicleData =
    watch(prevVeh ? "prevVehiclesList" : "vehiclesList") || [];

  const handleVehicleData = () => {
    setValue(prevVeh ? "prevNoMatchedData" : "noMatchedData", true);
    setValue(prevVeh ? "prevLookupData" : "lookupData", false);
    STATE.setLookupData(false);
    setValue("machedData", true);
    setValue(prevVeh ? "prevValuesMached" : "valuesMached", true);
  };

  const handleSelectVehicle = (index, item) => {
    setValue(prevVeh ? "prevVehiclesList" : "vehiclesList", "");

    if (prevVeh) {
      setValue("prevVehicleAbiCode", item.abiCode);
      setValue("prevVehicleModel", item.abiModel);
      setValue("prevVehicleMake", item.abiMake);
    } else {
      setValue("vehicleAbiCode", item.abiCode);
      setValue("vehicleModel", item.abiModel);
      setValue("vehicleMake", item.abiMake);
      setValue("vehicleCC", item.abiCC);
      setValue("bodyType", item.bodyType);
      setValue("vehicleCubicCapacity", item.abiCC);
    }

    // Clear follow-up questions when selecting a new vehicle
    setValue("vehImported", null);
    setValue("vehicleQPlated", null);
    setValue("seats", null);
    setValue("rightHandDrive", null);
    setValue("vehicleModified", null);
    setValue("dashCam", null);
    setValue("security", null);
    setValue("securityDevice", null);
    setValue("modifications", null);

    setValue("setSelectedVehicleIndex", index);
    setSelectedVehicleIndex(index);

    setValue("machedData", true);
    setValue("noMatchedData", true);
    setValue("valuesMached", true);
    setValue("lookupData", false);

    // Set the selected vehicle to lookupvehicleReg and switch to automatic mode
    setValue("lookupvehicleReg", item);
    setErrorVR(null);
    STATE.setIsManualVehicleEntry(false);
  };

  const handleVehicleDataYes = () => {
    trigger();
    setValue(prevVeh ? "prevNoMatchedData" : "noMatchedData", true);
    setValue(prevVeh ? "prevLookupData" : "lookupData", false);
    STATE.setLookupData(false);
    setValue("machedData", true);
    setValue(prevVeh ? "prevValuesMached" : "valuesMached", false);
  };

  const handleEnterManually = () => {
    // Clear vehicle lookup data
    if (prevVeh) {
      setValue("prevLookupvehicleReg", null);
      setValue("prevVehicleAbiCode", null);
      setValue("prevVehicleYear", null);
      setValue("prevVehicleMake", null);
      setValue("prevVehicleModel", null);
      setValue("prevVehicleRegDate", null);
      setValue("prevVehImported", null);
      setValue("prevVehicleQPlated", null);
      setValue("prevSeats", null);
      setValue("prevRightHandDrive", null);
      setValue("prevVehicleModified", null);
      setValue("prevLookupData", false);
      STATE.setLookupData(false);
    } else {
      setValue("vehicleRegDate", null);
      setValue("lookupData", false);
      setValue("noMatchedData", false);
      setValue("vehicleYear", null);
      STATE.setLookupData(false);
    }

    // Clear manual search fields
    setValue(prevVeh ? "prevMake" : "vMake", null);
    setValue(prevVeh ? "prevModel" : "vModel", null);
    setValue(prevVeh ? "prevVehicleYear" : "vehicleYear", null);
    setValue(prevVeh ? "prevVehicleDoor" : "vehicleDoor", null);
    setValue(prevVeh ? "prevNoMatchedData" : "noMatchedData", true);
    setValue(prevVeh ? "prevVehiclesList" : "vehiclesList", "");
    setValue("setSelectedVehicleIndex", null);

    // Toggle view states
    if (prevVeh) {
      setIsPrevVeh((prevState) => !prevState);
      setShowPrevButtons((prevState) => !prevState);
    } else {
      STATE.setIsManualVehicleEntry((prevState) => !prevState);
    }

    setfirst(false);
    setErrorVR("");
  };

  const handleEnterAuto = () => {
    STATE.setIsManualVehicleEntry(false);
  };
  const renderFollowUpQuestions = () => {
    return (
      <>
        {watch("noMatchedData") === true && !prevVeh && (
          <>
            {watch("valuesMached") === true && (
              <>
                <div className="">
                  <label className="labelName">Is your vehicle imported?</label>
                </div>

                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="vehImported"
                      {...register("vehImported", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="vehImported"
                      value="No"
                      {...register("vehImported", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {errors.vehImported && (
                  <span className="errorField radioError">Required</span>
                )}

                <label className="labelName">Is your vehicle Q-plated?</label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="vehicleQPlated"
                      {...register("vehicleQPlated", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="vehicleQPlated"
                      value="No"
                      {...register("vehicleQPlated", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {errors.vehicleQPlated && (
                  <span className="errorField radioError">Required</span>
                )}

                <LabelInput
                  id="seats"
                  label="Number of seats, including the driver?"
                  type="number"
                  placeholder="e.g. 5"
                  maxLength={1}
                  onInput={(e) => {
                    const value = e.target.value;
                    if (!/^[1-9]$/.test(value)) {
                      e.target.value = value.slice(0, -1);
                    }
                  }}
                  register={register("seats", {
                    required: "Required",
                    pattern: {
                      value: /^[1-9]$/,
                      message: "Please enter a single digit between 1 and 9",
                    },
                    min: {
                      value: 1,
                      message: "Please enter a number between 1 and 9",
                    },
                    max: {
                      value: 9,
                      message: "Please enter a number between 1 and 9",
                    },
                  })}
                  emailclass="emailClass"
                  errors={errors.seats}
                  watch={watch("seats")}
                  trigger={trigger}
                />

                <label className="labelName">
                  Is your vehicle a right hand drive
                </label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="radio"
                      {...register("rightHandDrive", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="radio"
                      value="No"
                      {...register("rightHandDrive", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {errors.rightHandDrive && (
                  <span className="errorField radioError">Required</span>
                )}

                <label className="labelName">
                  Has your vehicle been modified in any way?
                </label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="radio"
                      {...register("vehicleModified", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="radio"
                      value="No"
                      {...register("vehicleModified", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {errors.vehicleModified && (
                  <span className="errorField radioError">Required</span>
                )}
                {watch("vehicleModified") === "Yes" && (
                  <LabelInput
                    id="modifications"
                    label="Modifications"
                    type="select"
                    placeholder="Select Modifications"
                    options={convertArrayFormat(modifications)}
                    register={register("modifications", {
                      required: "Required",
                    })}
                    errors={errors?.modifications}
                    watch={watch("modifications")}
                    control={control}
                    isLoading={isLoading}
                    trigger={trigger}
                  />
                )}
              </>
            )}

            {watch("machedData") === true && !prevVeh && (
              <>
                <label className="labelName">
                  Do you have a dashcam installed in your vehicle?
                </label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="dashCam"
                      {...register("dashCam", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="dashCam"
                      value="No"
                      {...register("dashCam", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {errors.dashCam && (
                  <span className="errorField radioError">Required</span>
                )}

                <label className="labelName">
                  Does your vehicle have a security device fitted?
                </label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="radio"
                      {...register("security", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="radio"
                      value="No"
                      {...register("security", { required: true })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {errors.security && (
                  <span className="errorField radioError">Required</span>
                )}

                {watch("security") === "Yes" && (
                  <LabelInput
                    id="securityDevice"
                    label="What type of security device you have fitted"
                    type="select"
                    control={control}
                    isSearchable={true}
                    options={convertArrayFormat(security)}
                    placeholder="Enter security device "
                    register={register("securityDevice", {
                      required: "Required",
                    })}
                    errors={errors.securityDevice}
                    watch={watch("securityDevice")}
                    trigger={trigger}
                  />
                )}
              </>
            )}
          </>
        )}

        {watch("prevNoMatchedData") === true && prevVeh && (
          <>
            {watch("prevValuesMached") === true && (
              <>
                <div className="">
                  <label className="labelName">Is your vehicle imported?</label>
                </div>

                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="prevVehImported"
                      {...register("prevVehImported", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="prevVehImported"
                      value="No"
                      {...register("prevVehImported", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {prevVeh && errors.prevVehImported && (
                  <span className="errorField">Required</span>
                )}

                <label className="labelName">Is your vehicle Q-plated?</label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="prevVehQPlated"
                      {...register("prevVehQPlated", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="prevVehQPlated"
                      value="No"
                      {...register("prevVehQPlated", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {errors.vehicleQPlated && (
                  <span className="errorField radioError">Required</span>
                )}

                <LabelInput
                  id="prevSeats"
                  label="Number of seats, including the driver?"
                  type="number"
                  placeholder="e.g. 5"
                  maxLength={1}
                  onInput={(e) => {
                    const value = e.target.value;
                    if (!/^[1-9]$/.test(value)) {
                      e.target.value = value.slice(0, -1);
                    }
                  }}
                  register={register("prevSeats", {
                    required: prevVeh ? "Required" : false,
                    pattern: {
                      value: /^[1-9]$/,
                      message: "Please enter a single digit between 1 and 9",
                    },
                    min: {
                      value: 1,
                      message: "Please enter a number between 1 and 9",
                    },
                    max: {
                      value: 9,
                      message: "Please enter a number between 1 and 9",
                    },
                  })}
                  emailclass="emailClass"
                  errors={prevVeh && errors.prevSeats}
                  watch={watch("prevSeats")}
                  trigger={trigger}
                />

                <label className="labelName">
                  Is the vehicle right hand drive?
                </label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="radio"
                      {...register("prevRightHandDrive", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="radio"
                      value="No"
                      {...register("prevRightHandDrive", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {prevVeh && errors.prevRightHandDrive && (
                  <span className="errorField radioError">Required</span>
                )}

                <label className="labelName">
                  Has your vehicle been modified in any way?
                </label>
                <div className="radioGroup">
                  <label className="radioLabel">
                    <p className="radioLabels"> Yes</p>
                    <input
                      type="radio"
                      value="Yes"
                      name="radio"
                      {...register("prevVehicleModified", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="radioLabel">
                    <p className="radioLabels"> No</p>

                    <input
                      type="radio"
                      name="radio"
                      value="No"
                      {...register("prevVehicleModified", { required: false })}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                {prevVeh && errors.prevVehicleModified && (
                  <span className="errorField radioError">Required</span>
                )}
              </>
            )}
          </>
        )}
      </>
    );
  };
  return (
    <div className="fields">
      <LabelInput
        id={prevVeh ? "prevVehicleRegis" : "VehicleReg"}
        label="Vehicle registration"
        type="text"
        placeholder="e.g EA21 WLP"
        register={register(prevVeh ? "prevVehicleRegis" : "VehicleReg", {
          required: "Required",
        })}
        errors={prevVeh ? errors.prevVehicleRegis : errors.VehicleReg}
        watch={prevVeh ? prevVehicleRegis : VehicleReg}
        trigger={trigger}
        autoComplete="off"
      />

      {loader && <div className="loader"></div>}

      {STATE.isManualVehicleEntry && !prevVeh && (
        <>
          <LabelInput
            id={prevVeh ? "prevMake" : "vMake"}
            label="Vehicle make"
            type="select"
            options={convertArrayFormat(make)}
            control={control}
            placeholder="Enter make"
            register={register(prevVeh ? "prevMake" : "vMake", {
              required: "Required",
            })}
            onChange={() => setfirst(false)}
            errors={errors.vMake}
            watch={watch(prevVeh ? "prevMake" : "vMake")}
            trigger={trigger}
            isSearchable={true}
            isLoading={makesLoading}
          />
          <LabelInput
            id={prevVeh ? "prevModel" : "vModel"}
            label="Vehicle model"
            control={control}
            options={convertArrayFormat(model)}
            type="select"
            placeholder="Enter model"
            register={register(prevVeh ? "prevModel" : "vModel", {
              required: "Required",
            })}
            onChange={() => {
              setfirst(false);
            }}
            onSelect={() => {
              setfirst(false);
            }}
            errors={errors.vModel}
            watch={watch(prevVeh ? "prevModel" : "vModel")}
            trigger={trigger}
            isSearchable={true}
            isLoading={modelsLoading}
          />
          {watch("vModel") && (
            <>
              <LabelInput
                id={prevVeh ? "prevVehicleYear" : "vehicleYear"}
                label="Year"
                control={control}
                options={convertArrayFormat2(
                  watch(prevVeh ? "prevVehicleYearsList" : "vehicleYearsList")
                )}
                type="select"
                placeholder="Enter year"
                register={register(
                  prevVeh ? "prevVehicleYear" : "vehicleYear",
                  {
                    required: "Required",
                  }
                )}
                errors={errors.vehicleYear}
                onChange={() => {
                  setfirst(false);
                }}
                watch={watch(prevVeh ? "prevVehicleYear" : "vehicleYear")}
                disabled={make && Vehmodel.length === 0}
                trigger={trigger}
                isSearchable={true}
                isLoading={vehicleListIsLoading}
              />
              <LabelInput
                id={prevVeh ? "prevVehicleDoor" : "vehicleDoor"}
                label="Doors"
                onChange={() => setfirst(false)}
                control={control}
                options={convertArrayFormat2(
                  watch(prevVeh ? "prevVehicleDoorsList" : "vehicleDoorsList")
                )}
                type="select"
                placeholder="Enter doors"
                register={register(
                  prevVeh ? "prevVehicleDoor" : "vehicleDoor",
                  {
                    required: "Required",
                  }
                )}
                errors={errors.vehicleDoor}
                watch={watch(prevVeh ? "prevVehicleDoor" : "vehicleDoor")}
                disabled={make && Vehmodel.length === 0}
                trigger={trigger}
                isLoading={vehicleListIsLoading}
              />
            </>
          )}

          {watch("prevManualVehicleReg") !== null &&
            watch("prevManualVehicleReg") !== undefined &&
            prevVeh &&
            watch("vehRegistration") && (
              <>
                <p className="AddHeading">Vehicle Details 2</p>

                <div className="addressData">
                  <p className="">
                    {watch("prevManualVehicleReg").abiMake}-
                    {watch("prevManualVehicleReg").abiModel}{" "}
                  </p>

                  <p>
                    <p>{watch("prevManualVehicleReg").abiVehicleInfoDesc}</p>
                  </p>

                  <img src={assetsPath.tick} alt="Tick Icon" className="" />
                </div>
              </>
            )}
          {vehicleListIsLoading ? (
            <div className="vehicleListLoading">Loading vehicles...</div>
          ) : (
            vehicleData.length > 0 && (
              <div className="vehicleListWrapperContainer">
                <div className="vehicleListHeading">
                  <div>Select your vehicle</div>
                  <div className="vehicleListLength">
                    {watch("vehicleListLength")} Vehicle(s) Found
                  </div>
                </div>
                <div className="vehiclesListWrapper">
                  {vehicleData.map((item, index) => (
                    <button
                      key={index}
                      className="vehiclesListItem vehiclesListItemHover"
                      onClick={() => handleSelectVehicle(index, item)}
                      type="button"
                    >
                      <div className="vehicleListItemIcon">
                        <img
                          className="vehicleListItemIconImage"
                          src={assetsPath.carIcon}
                        />
                      </div>
                      <div className="vehicleMakeContent">
                        <div className="vehiclesMakeModel">
                          {item.abiMake ? `${item.abiMake} -` : "N/A"}{" "}
                          {item.abiModel || "N/A"}
                        </div>
                        <div className="vehiclesMakeModelInfo">
                          {item.abiVehicleInfoDesc || "N/A"}
                        </div>
                      </div>
                      {watch("setSelectedVehicleIndex") === index && (
                        <span className="tick">&#10004;</span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            )
          )}

          {errors.setSelectedVehicleIndex && (
            <p className="error-text">Please select a vehicle.</p>
          )}
        </>
      )}

      {!isPrevVeh && prevVeh && (
        <>
          <LabelInput
            id={prevVeh ? "prevMake" : "vMake"}
            label="Vehicle make"
            type="select"
            options={convertArrayFormat(make)}
            control={control}
            placeholder="Enter make"
            register={register(prevVeh ? "prevMake" : "vMake", {
              required: "Required",
            })}
            onChange={() => setfirst(false)}
            errors={errors.vMake}
            watch={watch(prevVeh ? "prevMake" : "vMake")}
            trigger={trigger}
            isSearchable={true}
          />
          <LabelInput
            id={prevVeh ? "prevModel" : "vModel"}
            label="Vehicle model"
            control={control}
            options={convertArrayFormat(model)}
            type="select"
            placeholder="Enter model"
            register={register(prevVeh ? "prevModel" : "vModel", {
              required: "Required",
            })}
            onChange={() => {
              setfirst(false);
            }}
            onSelect={() => {
              setfirst(false);
            }}
            errors={errors.vModel}
            watch={watch(prevVeh ? "prevModel" : "vModel")}
            trigger={trigger}
            isSearchable={true}
          />
          <LabelInput
            id={prevVeh ? "prevVehicleYear" : "vehicleYear"}
            label="Year"
            control={control}
            options={convertArrayFormat2(
              watch(prevVeh ? "prevVehicleYearsList" : "vehicleYearsList")
            )}
            type="select"
            placeholder="Enter year"
            register={register(prevVeh ? "prevVehicleYear" : "vehicleYear", {
              required: "Required",
            })}
            errors={errors.vehicleYear}
            onChange={() => {
              setfirst(false);
            }}
            watch={watch(prevVeh ? "prevVehicleYear" : "vehicleYear")}
            disabled={make && Vehmodel.length === 0}
            trigger={trigger}
            isSearchable={true}
          />
          <LabelInput
            id={prevVeh ? "prevVehicleDoor" : "vehicleDoor"}
            label="Doors"
            onChange={() => setfirst(false)}
            control={control}
            options={convertArrayFormat2(
              watch(prevVeh ? "prevVehicleDoorsList" : "vehicleDoorsList")
            )}
            type="select"
            placeholder="Enter doors"
            register={register(prevVeh ? "prevVehicleDoor" : "vehicleDoor", {
              required: "Required",
            })}
            errors={errors.vehicleDoor}
            watch={watch(prevVeh ? "prevVehicleDoor" : "vehicleDoor")}
            disabled={make && Vehmodel.length === 0}
            trigger={trigger}
          />

          {watch("manualVehicleReg") && !prevVeh && (
            <>
              <p className="AddHeading">Vehicle Details 3</p>
              <div className="addressData">
                <p className="">
                  {watch("manualVehicleReg").abiMake}-
                  {watch("manualVehicleReg").abiModel}{" "}
                </p>

                <p>
                  <p>{watch("manualVehicleReg").abiVehicleInfoDesc}</p>
                </p>

                <img src={assetsPath.tick} alt="Tick Icon" className="" />
              </div>
            </>
          )}

          {watch("prevManualVehicleReg") && prevVeh && (
            <>
              <p className="AddHeading">Vehicle Details 4</p>
              <div className="addressData">
                <p className="">
                  {watch("prevManualVehicleReg").abiMake}-
                  {watch("prevManualVehicleReg").abiModel}{" "}
                </p>

                <p>
                  <p>{watch("prevManualVehicleReg").abiVehicleInfoDesc}</p>
                </p>

                <img src={assetsPath.tick} alt="Tick Icon" className="" />
              </div>
            </>
          )}
          {vehicleData.length > 0 && (
            <h3>{watch("vehicleListLength")} Vehicle Found</h3>
          )}
          <div className="vehiclesListWrapper">
            {vehicleData.map((item, index) => (
              <>
                <div
                  className={`vehiclesMakeDiv ${
                    watch("setSelectedVehicleIndex") === index
                      ? "selectedVehicle"
                      : ""
                  }`}
                  key={index}
                >
                  <div className="vehiclesMakeModel">
                    <h3>{item.abiMake ? `${item.abiMake} -` : "N/A"}</h3>
                    <h3>{item.abiModel ? item.abiModel : "N/A"}</h3>
                  </div>
                  <div>
                    <div></div>
                  </div>
                  <div className="vehiclesMakeModel"></div>
                  <div className="vehiclesMakeModel">
                    <p>
                      {item.abiVehicleInfoDesc
                        ? item.abiVehicleInfoDesc
                        : "N/A "}
                      &nbsp;
                    </p>
                  </div>
                  <div className="vehicleSelectBtn">
                    <button
                      type="button"
                      onClick={() => handleSelectVehicle(index, item)}
                      className={`lookupBtn ${
                        watch("setSelectedVehicleIndex") === index
                        // ? "lookbtn3"
                        // : ""
                      }`}
                    >
                      {watch("setSelectedVehicleIndex") === index ? (
                        <>
                          Vehicle Selected{" "}
                          <span className="tickdesign">&#10004;</span>
                        </>
                      ) : (
                        "Select Vehicle"
                      )}
                    </button>
                  </div>
                </div>
                {selectedVehicleIndex === null && (
                  <p className="error-text">
                    Please select a vehicle before proceeding.
                  </p>
                )}
              </>
            ))}
          </div>
        </>
      )}

      <input
        id="lookupvehicleReg"
        className="hiddenInput"
        name="lookupvehicleReg"
        type="text"
        {...register("lookupvehicleReg", {
          validate: (value) =>
            !watch("VehicleReg") ||
            value !== "" ||
            "This field is required if Vehicle Registration has a value",
        })}
      />

      {!isPrevVeh && <span className="errorField">{errorVR}</span>}
      {watch("lookupvehicleReg") && !STATE.isManualVehicleEntry && !prevVeh && (
        <>
          <p className="AddHeadingLookUp">Vehicle Details</p>
          <div className="vehicleData">
            <div>
              <p>
                {watch("lookupvehicleReg").abiMake
                  ? watch("lookupvehicleReg").abiMake
                  : watch("lookupvehicleReg").make}{" "}
                &nbsp;{" "}
              </p>
              <p>
                {watch("lookupvehicleReg").abiModel
                  ? watch("lookupvehicleReg").abiModel
                  : watch("lookupvehicleReg").model}{" "}
                &nbsp;{" "}
              </p>
            </div>
            <div>
              <p>
                {watch("lookupvehicleReg").abiVehicleInfoDesc
                  ? watch("lookupvehicleReg").abiVehicleInfoDesc
                  : watch("lookupvehicleReg").preVehicleSearch}
              </p>
            </div>
            <img src={assetsPath.tick} alt="Tick Icon" className="" />
          </div>
        </>
      )}

      {isPrevVeh && (
        <input
          id="prevLookupVehicleReg"
          className="hiddenInput"
          name="prevLookupVehicleReg"
          type="text"
          {...register("prevLookupVehicleReg", {
            validate: (value) =>
              !watch("VehicleReg") ||
              value !== "" ||
              "This field is required if Vehicle Registration has a value",
          })}
        />
      )}

      {isPrevVeh && <span className="errorField">{errorVR}</span>}
      {watch("prevLookupVehicleReg") &&
        watch("prevVehicleAbiCode") &&
        // watch("vehRegistration") &&
        Object.keys(watch("prevLookupVehicleReg")).length > 0 &&
        isPrevVeh &&
        prevVeh && (
          <>
            <p className="AddHeadingLookUp">Vehicle Details 6</p>
            <div className="vehicleData">
              <div>
                <p>
                  {watch("prevLookupVehicleReg")?.abiMake
                    ? watch("prevLookupVehicleReg")?.abiMake
                    : watch("prevLookupVehicleReg")?.make}{" "}
                  &nbsp;{" "}
                </p>
                <p>
                  {watch("prevLookupVehicleReg")?.abiModel
                    ? watch("prevLookupVehicleReg")?.abiModel
                    : watch("prevLookupVehicleReg")?.model}{" "}
                  &nbsp;{" "}
                </p>
              </div>
              <div>
                <p>
                  {watch("prevLookupVehicleReg")?.abiVehicleInfoDesc
                    ? watch("prevLookupVehicleReg")?.abiVehicleInfoDesc
                    : watch("prevLookupVehicleReg")?.preVehicleSearch}
                </p>
              </div>
              <img src={assetsPath.tick} alt="Tick Icon" className="" />
            </div>
          </>
        )}

      {prevVeh ? (
        <div className={`${isPrevVeh ? "addressButton" : "ManualAddBtn"} `}>
          {showPrevButtons && (
            <button
              type="button"
              className="lookupBtn"
              onClick={handleVehicleReg}
            >
              Automatic Look up
            </button>
          )}
          <button
            onClick={handleEnterManually}
            type="button"
            className={`${isPrevVeh ? "lookupBtn" : "lookupBtn"} `}
          >
            {isPrevVeh ? "Enter manually" : "Look Vehicle Registration"}
          </button>
        </div>
      ) : (
        <div
          className={`${
            !STATE.isManualVehicleEntry ? "addressButton" : "ManualAddBtn"
          } `}
        >
          {/* Only show the button if not in manual entry mode */}
          {!STATE.isManualVehicleEntry && (
            <button
              type="button"
              className="lookupBtn bg-black"
              onClick={handleVehicleReg}
            >
              Look up registration
            </button>
          )}
          <button
            onClick={
              !STATE.isManualVehicleEntry
                ? handleEnterManually
                : handleEnterAuto
            }
            type="button"
            className="lookupBtn bg-gray"
          >
            {!STATE.isManualVehicleEntry
              ? "Enter manually"
              : "Automatic Look up"}
          </button>
        </div>
      )}

      {watch("lookupData") === true && STATE.lookupData === true && !prevVeh && (
        <div className="vehicleDataPanel margin-bottom-10">
          <h3>This Vehicle:</h3>
          <p>
            &#x2022;{" "}
            {`Is ${
              watch("vehImported") === "Yes" ? "imported" : "NOT imported"
            }`}
          </p>
          <p>
            &#x2022;{" "}
            {`Is ${
              watch("vehicleQPlated") === "No" ? "NOT Q plated" : "Q Plated"
            }`}
          </p>
          <p>
            &#x2022;{" "}
            {`has ${
              watch("seats") ? `${watch("seats")} seats` : "no seats found"
            }`}
          </p>
          <p>
            &#x2022;{" "}
            {`Is ${
              watch("rightHandDrive") === "Yes"
                ? "right hand drive"
                : "left hand drive"
            }`}
          </p>
          <p>
            &#x2022;{" "}
            {`Is ${
              watch("vehicleModified") === "No"
                ? "NOT modified in any way"
                : "Modified"
            }`}
          </p>

          <p>Are these details correct?</p>
          <div className="correctButtonDiv">
            <button
              onClick={() => {
                handleVehicleDataYes();
                setValue("vehicleDetailsCorrect", "Yes"); // Set field value to Yes
              }}
              type="button"
              className="lookupBtn bg-black"
            >
              Yes
            </button>

            <button
              onClick={() => {
                handleVehicleData();
                setValue("vehicleDetailsCorrect", "No"); // Set field value to No
              }}
              type="button"
              className="lookupBtn bg-gray"
            >
              Edit
            </button>
          </div>

          {/* Invisible field for storing the user's choice */}
          <input
            type="hidden"
            {...register("vehicleDetailsCorrect", {
              validate: (value) =>
                value === "Yes" || value === "No" || "Please select Yes or No",
            })}
          />
        </div>
      )}

      {renderFollowUpQuestions()}
    </div>
  );
};

export default VehicleLookupNew;
